/**
 * Manage the how Access User Login data and Auth Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to sessionStorage or localStorage
**/

// a unique key that identifies app storage values
const myAppStoreKey = process.env.STORAGE_KEY || "APP";

// key for user access token
const TOKEN_KEY = myAppStoreKey + '_TOKEN';

// key to remember user locale
const LOCALE_KEY = myAppStoreKey + '_LOCALE';

// key to keep the latest rejected/403 context for support flow
const REJECTED_CONTEXT_KEY = myAppStoreKey + '_REJECTED_CONTEXT';

// key to queue connectivity reports to flush when network restores
const PENDING_CONNECTIVITY_KEY = myAppStoreKey + '_PENDING_CONNECTIVITY';

export const StorageService = {
    setLocale(locale) {
        localStorage.setItem(LOCALE_KEY, locale);
    },
    getLocale() {
        return localStorage.getItem(LOCALE_KEY);
    },
    saveRejectedContext(context) {
        sessionStorage.setItem(REJECTED_CONTEXT_KEY, JSON.stringify(context || {}));
    },
    getRejectedContext() {
        const raw = sessionStorage.getItem(REJECTED_CONTEXT_KEY);
        if (!raw) {
            return null;
        }

        try {
            return JSON.parse(raw);
        }
        catch (err) {
            console.warn('Falha ao ler contexto de rejected do storage:', err);
            return null;
        }
    },
    clearRejectedContext() {
        sessionStorage.removeItem(REJECTED_CONTEXT_KEY);
    },
    getToken() {
        return sessionStorage.getItem(TOKEN_KEY)  || localStorage.getItem(TOKEN_KEY);
    },
    saveLoginData(loginData, remember) {
        let token = loginData.token;
        if(remember){
            localStorage.setItem(TOKEN_KEY, token);
        }
        else{
            sessionStorage.setItem(TOKEN_KEY, token);
        }
    },
    removeLoginData() {
        sessionStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(TOKEN_KEY);
        // uncomment to remove language locale when user logout
        //localStorage.removeItem(LOCALE_KEY);
    },
    savePendingConnectivityReport(payload) {
        const existing = this.getPendingConnectivityReports();
        const reportKey = `${payload.alertType}:${payload.requestMethod}:${payload.requestUrl}:${payload.appVersion}`;
        const alreadyQueued = existing.some(r => `${r.alertType}:${r.requestMethod}:${r.requestUrl}:${r.appVersion}` === reportKey);
        if (alreadyQueued) return;
        existing.push(payload);
        localStorage.setItem(PENDING_CONNECTIVITY_KEY, JSON.stringify(existing));
    },
    getPendingConnectivityReports() {
        try {
            return JSON.parse(localStorage.getItem(PENDING_CONNECTIVITY_KEY) || '[]');
        } catch { return []; }
    },
    clearPendingConnectivityReports() {
        localStorage.removeItem(PENDING_CONNECTIVITY_KEY);
    },
    setPendingConnectivityReports(reports) {
        localStorage.setItem(PENDING_CONNECTIVITY_KEY, JSON.stringify(reports || []));
    },
}
